import { BadgeVariants } from "ds/components/Badge/types";
import Badge from "ds/components/Badge";

import { ApiKeyGroupMappingStatus } from "./types";

type ApiKeyGroupMappingStatusConfig = {
  variant: BadgeVariants;
  text: string;
};

const API_KEY_GROUP_MAPPING_STATUSES: Record<
  ApiKeyGroupMappingStatus,
  ApiKeyGroupMappingStatusConfig
> = {
  [ApiKeyGroupMappingStatus.MAPPED]: { variant: "green", text: "Mapped" },
  [ApiKeyGroupMappingStatus.UNMAPPED]: { variant: "yellow", text: "Unmapped" },
};

type ApiKeyGroupMappingStatusBadgeProps = {
  status: ApiKeyGroupMappingStatus;
  className?: string;
};

const ApiKeyGroupMappingStatusBadge = ({
  status,
  className,
}: ApiKeyGroupMappingStatusBadgeProps) => {
  return (
    <Badge
      variant={API_KEY_GROUP_MAPPING_STATUSES[status].variant}
      type="strong"
      className={className}
      text={API_KEY_GROUP_MAPPING_STATUSES[status].text}
    />
  );
};

export default ApiKeyGroupMappingStatusBadge;
